import { DarkTheme, DefaultTheme } from "expo-router/react-navigation";

export const DarkTransparentTheme = {
  ...DarkTheme,
  colors: {
    ...DarkTheme.colors,
    background: 'transparent', // Makes the overall app background transparent
    card: 'transparent', // Makes card-like elements (headers, tab bars) transparent
  },
};

export const LightTransparentTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: 'transparent', // Makes the overall app background transparent
    card: 'transparent', // Makes card-like elements (headers, tab bars) transparent
  },
};
